import { createFileRoute } from '@tanstack/react-router';
import { DeviceDetailLayout } from '@/features/devices/components';

// Layout route for a single device: renders the header + tab bar and an Outlet for the
// active tab route.
export const Route = createFileRoute('/_app/devices/$deviceId')({
  component: DeviceDetailLayout,
});
